import Button from "@/Components/Button";
import Image from "next/image";
import dynamic from "next/dynamic";
const MobileSlider = dynamic(() => import("../Banner/mobile-slider"), { ssr: true });
import { toWebp } from "@/utils/common";
import Link from "next/link";

interface CRMSystemprops {
  isMobile: any;
  data?: any;
}

const baseUrl = `${process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL}`;

const CRMSystem: React.FC<CRMSystemprops> = ({ isMobile, data }) => {
  return (
    <div className="bg-background-dark text-white relative">
      <section className="bg-background-white xl:py-25 md:py-[80px] py-[56px] relative">
        <div className="container mx-auto px-4 relative z-10">
          {/* Heading */}
          <h2 className="text-heading-1 font-bold text-center capitalize max-w-[1240px] mx-auto mb-[24px]">
            {data?.title}
          </h2>

          {data?.cta?.href && data?.cta?.label && (
            <Link href={data?.cta?.href}>
              <div className="max-auto text-center flex items-center justify-center mb-[40px]">
                <Button
                  label={data?.cta?.label}
                  className="text-subtitle-4"
                />
              </div>
            </Link>
          )}

          {!isMobile && (
            <>
              {/* Grid */}
              <div className="grid grid-cols-1 gap-[30px] xl:gap-[80px] md:gap-[56px]">
                {data?.services?.map((data: any, index: number) => (
                  <div
                    key={data?.id}
                    className="border border-[#32343B] group relative  overflow-hidden bg-background-dark"
                  >
                    <div
                      className={`overflow-hidden h-full grid sm:grid-cols-2 justify-center ${index % 2 === 0 ? "sm:[&>*:first-child]:order-2" : ""
                        }`}
                    >
                      {/* Content Section */}
                      <div className="flex flex-col  items-start min-h-[440px] max-h-[auto] justify-center text-left flex-1 p-[32px_24px_56px_24px] lg:p-[32px_30px_56px_30px] relative">
                        <h3 className="text-secondary-text-white xl:text-heading-4 lg:text-[32px] md:text-[24px] font-bold mb-[12px] xl:mb-[24px] max-w-[540px] transition-colors duration-300">
                          {data?.title}
                        </h3>
                        <p
                          className="text-secondary-text-white text-subtitle-1
                      
                        transition-all duration-500 ease-out delay-150"
                        >
                          {data?.description}
                        </p>
                      </div>

                      {/* Image Section */}
                      {data?.image?.data?.attributes?.url && (
                        <div className="h-full overflow-hidden">
                          {/* Image visible only on < sm */}
                          <Image
                            src={`${baseUrl}${data?.image?.data?.attributes?.url}`}
                            alt={data?.title}
                            width={600}
                            height={440}
                            className="w-full h-full object-cover md:min-h-[440px] md:max-h-[auto] 
                            transition-all duration-700 ease-out transform 
                            group-hover:scale-105 group-hover:-translate-y-2"
                          />
                        </div>
                      )}
                    </div>

                    {/* Background overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out pointer-events-none"></div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {isMobile && (
          <>
            <MobileSlider>
              {data?.services?.map((data?: any) => (
                <div
                  key={data?.id}
                  className="border border-[#32343B] group relative card-approch overflow-hidden bg-background-dark"
                >
                  <div
                    className={`overflow-hidden h-full grid sm:grid-cols-2 grid-cols-1 gap-[30px] justify-center `}
                  >
                    {/* Image Section */}
                    {data?.image?.data?.attributes?.url && (
                      <div className="h-[440px] overflow-hidden">
                        <Image
                          src={toWebp(`${baseUrl}${data?.image?.data?.attributes?.url}`)}
                          alt={data?.title}
                          width={600}
                          height={440}
                          className="w-full h-full object-cover md:min-h-[440px] md:max-h-[440px] 
                        transition-all duration-700 ease-out transform 
                        group-hover:scale-105 group-hover:-translate-y-2"
                        />
                      </div>
                    )}

                    {/* Content Section */}
                    <div className="flex flex-col items-center md:items-start min-h-[440px] max-h-[440px] justify-center text-center md:text-left flex-1 p-[32px_24px_56px_24px] lg:p-[32px_30px_56px_30px] card-hover-approch relative">
                      <h3 className="text-secondary-text-white xl:text-heading-4 lg:text-[32px] md:text-[24px] font-bold mb-[12px] xl:mb-[24px] max-w-[540px] transition-colors duration-300">
                        {data?.title}
                      </h3>
                      <p className="text-secondary-text-white text-subtitle-1 transition-all duration-500 ease-out delay-150">
                        {data?.description}
                      </p>
                    </div>
                  </div>

                  {/* Background overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out pointer-events-none"></div>
                </div>
              ))}
            </MobileSlider>
          </>
        )}

        {/* Background Images */}
        {
          !isMobile && (
            <div
              className="
            absolute w-full h-full top-0 left-0 right-0 bottom-0 z-0
            bg-no-repeat bg-cover bg-top
            hidden md:block
          "
              style={{
                backgroundImage: "url('/images/crm/troo-approach.png')",
              }}
            ></div>
          )
        }
        {
          isMobile && (
            <div
              className="
            absolute w-full h-full top-0 left-0 right-0 bottom-0 z-0
            bg-no-repeat bg-cover bg-top
            block md:hidden
          "
              style={{
                backgroundImage: "url('/images/consulting/bg-approch-mobile.png')",
              }}
            ></div>
          )
        }
      </section>
    </div>
  );
};
export default CRMSystem;